import React, {useState} from "react";
import {__} from "@wordpress/i18n";
import {MultiStepContactForm} from "../Form/MultiStepContactForm";
import {SingleStepContactForm} from "../Form/SingleStepContactForm";

export function ContactFormMessage({text}: ({ text: string })): React.ReactElement {
    const [formType, setFormType] = useState<string>('default');

    switch( formType ) {
        case 'short':
            return (<SingleStepContactForm/>);

        case 'steps':
            return (<MultiStepContactForm/>);

        default:
            return (
                <div className="wvcb-card">
                    <div className="wvcb-contact-form">
                        <p>{text}</p>
                        <div className="wvcb-toggles wvcb-toggles--contact-form">
                            <button className="wvcb-toggle" onClick={() => setFormType('steps')}>
                                <header className="wvcb-toggle__header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round"
                                         className="lucide lucide-proportions-icon lucide-proportions">
                                        <rect width="20" height="16" x="2" y="4" rx="2"/>
                                        <path d="M12 9v11"/>
                                        <path d="M2 9h13a2 2 0 0 1 2 2v9"/>
                                    </svg>
                                    <aside className="wvcb-toggle__timestamp">ca. 3-5 min</aside>
                                </header>
                                <p className="wvcb-toggle__title">{__('Mehrstufiges Formular', 'wv-chat-bot')}</p>
                            </button>
                            <button className="wvcb-toggle" onClick={() => setFormType('short')}>
                                <header className="wvcb-toggle__header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round" className="lucide lucide-mail-icon lucide-mail">
                                        <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/>
                                        <rect x="2" y="4" width="20" height="16" rx="2"/>
                                    </svg>
                                    <aside className="wvcb-toggle__timestamp">ca. 2 min</aside>
                                </header>
                                <p className="wvcb-toggle__title">{__('Einfach & schnelles Formular', 'wv-chat-bot')}</p>
                            </button>
                        </div>
                    </div>
                </div>
            );
    }
}
